import classnames from 'classnames';
import React from 'react';

/**
 * Base dialog type displays dialog as either modal or drawer, and which is the heart of the dialog component
 * @param props DialogTypeProps
 */ const DialogType = (props)=>{
    const { animation, 'aria-labelledby': ariaLabelledBy, children, className, height, id, size, style, type, width, ...otherProps } = props;
    // position is used for drawer dialogs
    // fade-in-from-left => left
    // fade-in-from-right => right
    const position = animation.split('-').pop();
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        "aria-labelledby": ariaLabelledBy,
        "aria-modal": true,
        className: classnames({
            'bf-dialog__type': true,
            [`bf-dialog__type--${type}`]: type,
            [`bf-dialog__type--animation-${animation}`]: animation,
            [`bf-dialog__type--position-${position}`]: position,
            [`bf-dialog__type--size-${size}`]: size,
            [`${className}`]: !!className
        }),
        id: id,
        role: "dialog",
        style: {
            ...style,
            height: height !== undefined && height > 0 ? height : undefined,
            width: width !== undefined && width > 0 ? width : undefined
        }
    }, children);
};

export { DialogType };
//# sourceMappingURL=dialog-type.js.map
